import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmApiNeedSmsTfaError } from '@/core/error/transport/customErrors/tmApiNeedSmsTfaError'

export const authNeedTFASmsConfirmationRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.enter_two_factor_code'],
  klass: TmApiNeedSmsTfaError,
}
